import { render } from "./ViewEntriesCollectors.vue?vue&type=template&id=279c97e7&scoped=true"
import script from "./ViewEntriesCollectors.vue?vue&type=script&lang=js"
export * from "./ViewEntriesCollectors.vue?vue&type=script&lang=js"

import "./ViewEntriesCollectors.vue?vue&type=style&index=0&id=279c97e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279c97e7"]])

export default __exports__